import { Box, BoxProps, CircularProgress } from '@/primitives';

export function LoadingPage(props: BoxProps) {
  return (
    <Box
      {...props}
      sx={[
        {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '65vh',
          width: '100%',
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}
    >
      <CircularProgress />
    </Box>
  );
}
